import { render, staticRenderFns } from "./SSelectAreaScire.vue?vue&type=template&id=3f837892"
import script from "./SSelectAreaScire.vue?vue&type=script&lang=js"
export * from "./SSelectAreaScire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports